export default "__VITE_ASSET__CHkDduHO__"